import React, { useEffect } from 'react';
import classNames from "classnames";

import Editor from './Editor';
import Result from './Result';
import EmptyResult from './EmptyResult';
import Modal from './Modal';
import Prompt from './Prompt';
import ShortPrompts from './ShortPrompts';
import Error from './Error';

import { useCopywriter, useCopywriterDispatch } from './CopywriterContext';

const Assistent = () => {

  const { content, onChange, result, fetching, error, onCancel = () => {} } = useCopywriter();
  const dispatch = useCopywriterDispatch();

  const disabled = !result || !result.length;

  const handleClose = () => {
    dispatch({ type: 'toggle' });
    onCancel();
  }

  const handleSave = () => {
    if(!result || !result.length) return;

    onChange(result);
    handleClose();
  }

  const handleSelect = (prompt) => {
    if (fetching) return;

    dispatch({ type: 'update_prompt', prompt })
    dispatch({ type: 'emit_fetching' })
  }

  const handleCopy = () => {
    if(fetching || disabled) return; 

    dispatch({ type: 'update_content', content: result });
  }


  // const arrowNavClasses = classNames(
  //   "s-copywriter-assistant__arrow",
  //   // Поменяй замоканное условие
  //   { "s-copywriter-assistant__arrow_gray": false }
  // );

  return (
    <Modal onAction={handleSave} onClose={handleClose} disabled={disabled}>
      <div className="s-copywriter-assistant">
        <div className="s-copywriter-assistant__editor-wrapper">
          {/* <div className="s-copywriter-assistant__editor-title-wrapper"> */}
            {/* <h3 className="s-copywriter-assistant__editor-title">{i18n.t('assistant.text_original')}</h3> */}
            {/* <div className="s-copywriter-assistant__arrow-nav"> */}
            {/*   <button className={arrowNavClasses} title='mock-title'> */}
            {/*     <i className="fa fa-mail-reply" /> */}
            {/*   </button> */}
            {/*   <button className={arrowNavClasses} title='mock-title'> */}
            {/*     <i className="fa fa fa-share" /> */}
            {/*   </button> */}
            {/* </div> */}
          {/* </div> */}
          <Editor
            value={content}
            onChange={(content) => dispatch({ type: 'update_content', content })}
          />
        </div>

        <button className="s-copywriter-assistant__arrow-left" title={i18n.t('assistant.copy')} onClick={handleCopy} disabled={fetching || disabled}>
          <i className="fi fi-arrow-left" />
        </button>

        <div className="s-copywriter-assistant__editor-wrapper">
          {/* <h3 className="s-copywriter-assistant__editor-title">{i18n.t('assistant.text_ai')}</h3> */}
          <Result value={result}>
            {error ? (<Error />) : (
              (!result || fetching) && <>
                <EmptyResult />
                {fetching && <div className="preloader" />}
              </>
            )}
          </Result>
        </div>
        <Prompt />
        <ShortPrompts disabled={fetching} onSelect={handleSelect} />
      </div>
    </Modal>
  );
};

export default Assistent;
